export default __webpack_public_path__ + "static/media/Paw.f8ab1160.svg";